import React from "react";

const OrderDetails = (props) => {
  // console.log(props.order)
  const { bookName, Quantity, authorName, Price } = props.order;
  return (
    <tr>
      <td>{bookName}</td>
      <td>{authorName}</td>
      <td>{Quantity}</td>
      <td>{Price}</td>
    </tr>
  );
};

export default OrderDetails;
